module.exports = __webpack_public_path__ + "static/media/cancel-btn@2x.dfcf6fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/cancel-btn@2x.png
// module id = 834
// module chunks = 0